export class CompanyInfo {
    constructor(name, phonenumber, storage,LogoFileData,companyId) {
      this.name = name;
      this.phonenumber = phonenumber;
      this.storage = storage;
      this.LogoFileData=LogoFileData;
      this.companyId=companyId;
    }
  }
  